import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import Media from 'components/Media/Media.component'

import PassportFooter from '../Footer/PassportFooter'
import { getBrandProfileUrl } from '../utils'
import FavoriteButton from './FavoriteButton.container'
// this import is problematic and collides with imports of Media.component.module
// for some reason
import styles from './Favorites.module.css'

const FavoriteBrand = ({ brand, isLoggedIn }) => (
  <div className={styles.brand}>
    <Link
      data-testid="brand"
      to={getBrandProfileUrl({ brandId: brand.id }, isLoggedIn)}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Media mediaSource={brand.mainImage} previewImageSized />
    </Link>
    <div className={styles.brandInfo}>
      <p
        className={classNames('tw-uppercase tw-font-normal', styles.brandName)}
      >
        {brand.name}
      </p>
      <FavoriteButton
        event={{ id: '', name: brand.eventSlug }}
        brand={{ brandId: brand.id }}
      />
    </div>
  </div>
)

FavoriteBrand.propTypes = {
  brand: PropTypes.object.isRequired,
}

const FavoritesPage = ({ favoritedBrands, isLoggedIn }) => (
  <div className={styles.FavoritesPage}>
    <div className="tw-container tw-mx-auto">
      <p
        className={classNames(
          styles.favoritesHeader,
          'tw-mt-20 tw-mb-12 tw-text-3xl tw-font-display tw-font-medium tw-text-primary-600 tw-text-center',
        )}
      >
        FAVORITES
      </p>
      {Boolean(favoritedBrands.length) && (
        <div
          className={classNames(
            'tw-grid tw-grid-cols-1 tw-gap-y-10 tw-gap-x-5  sm:tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-5',
          )}
        >
          {favoritedBrands.map((brand) => (
            <FavoriteBrand
              brand={brand}
              key={brand.id}
              isLoggedIn={isLoggedIn}
            />
          ))}
        </div>
      )}
    </div>
    <PassportFooter />
  </div>
)

FavoritesPage.propTypes = {
  favoritedBrands: PropTypes.array,
  isLoggedIn: PropTypes.bool.isRequired,
}

FavoritesPage.defaultProps = {
  favoritedBrands: [],
}

export default FavoritesPage
